import { render } from "./FpLoader.vue?vue&type=template&id=1fa78310&lang=pug"
import script from "./FpLoader.vue?vue&type=script&lang=js"
export * from "./FpLoader.vue?vue&type=script&lang=js"

import "./FpLoader.vue?vue&type=style&index=0&id=1fa78310&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__